import { useState } from "react";
import { WelcomeWizard } from "@/components/onboarding/WelcomeWizard";
import { DashboardProductTour } from "@/components/DashboardProductTour";
import { useSetupCentre } from "@/hooks/useSetupCentre";

/**
 * First-run experience launcher (additive).
 * - Shows the welcome wizard once per company (new accounts only)
 * - Offers the existing product tour
 * - Raises milestone celebrations as setup progresses
 */
export function OnboardingLauncher() {
  const { loading, prefs, completeWizard, completeTour } = useSetupCentre({ celebrate: true });
  const [tourOpen, setTourOpen] = useState(false);

  if (loading || !prefs.enabled) return null;

  const showWizard = !prefs.wizardCompleted;
  const showTour = tourOpen || (prefs.wizardCompleted && !prefs.tourCompleted);

  return (
    <>
      <WelcomeWizard
        open={showWizard}
        onComplete={() => void completeWizard()}
        onStartTour={() => setTourOpen(true)}
      />
      {!showWizard && showTour && (
        <DashboardProductTour
          onComplete={() => {
            setTourOpen(false);
            void completeTour();
          }}
        />
      )}
    </>
  );
}

export default OnboardingLauncher;
